// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29aNL","rootMobile":"styles_rootMobile__2UaXZ"};